<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-md-offset-1">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard ref="wizard" error-color="#EB5E28" color="#1e94fd" title="Aclaraciones" subtitle="">
            <div>
              <b-tabs content-class="">
                <b-tab title="Subir aclaraciones" active lazy class="tab-cont rounded-bottom">
                  <aclaraciones ref="Aclaraciones"></aclaraciones>
                </b-tab>
<!--                 <b-tab title="Solicitud de modificación" lazy class="tab-cont rounded-bottom">
                  <solicitud ref="Solicitud"></solicitud>
                </b-tab> -->
              </b-tabs>
            </div>
            <button slot="next" class="d-none">Siguiente</button>
            <button slot="finish" class="d-none">Siguientes</button>
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    FormWizard,
    TabContent
  } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
  import Aclaraciones from "./Formularios/Aclaraciones/Aclaraciones.vue";
  //import solicitud from "./Formularios/Aclaraciones/Solicitud.vue";
  import moment from 'moment';
  import swal from "sweetalert2";
  export default {
    components: {
      FormWizard,
      Aclaraciones,
      //solicitud
    },
    data() {
      return {

      };
    },
    watch: {
      '$route': 'checkP'
    },
    methods: {

    },
    created() {

    },
    mounted() {
      //this.checkCatalogs();
      this.$refs.wizard.activateAll();
    }
  };

</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9a9a9a !important;
    color: white;
  }


  .custom-file-label::after {
    content: "Buscar" !important;

  }

  .tab-cont {
    border-bottom: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
    /* border-end-end-radius: .25rem; */
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Aclaraciones.vue